export default "__VITE_ASSET__BNRnxmoe__"